// extracted by mini-css-extract-plugin
export default {"static":"Static-module__static--oWkk1"};